module.exports = __webpack_public_path__ + "static/media/barber-back.ee2cd593.jpg";